import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {GNBDataLevelOne, RightSubMenuData} from "../../types";
import {DrpDownLabel, DrpDownRight, LeftArrowIcon} from "../HeaderStyled";
import RightMenu from "./RightMenu";
import Anchor from "../../../HTMLEntities/Anchor";
import config from "../../../../config/config";

interface Props {
    leftMenuData: GNBDataLevelOne[];
    openSubSectionDiv: (index: string) => void;
    activeLeftTabIndex: string[];
    rightSubMenuData: RightSubMenuData;
    navMenuClick: () => void;
    setHamburgerOpenState: React.Dispatch<React.SetStateAction<string>>;
}

const LeftMenuLi: React.FC<Props> = ({
    leftMenuData,
    openSubSectionDiv,
    activeLeftTabIndex,
    rightSubMenuData,
    navMenuClick,
    setHamburgerOpenState,
}: Props) => {
    console.log(leftMenuData, "leftMenuDataleftMenuData");
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    return useMemo(() => {
        return (
            <ul className="g_lev2">
                {leftMenuData.map((mainSection, index) => {
                    const labelActive = activeLeftTabIndex.indexOf(`ms_${index}`) !== -1;
                    return (
                        <li
                            key={`ms_${index}`}
                            onClick={() => {
                                setHamburgerOpenState(`ms_${index}`);
                                openSubSectionDiv(`ms_${index}`);
                            }}
                            {...(isMobile
                                ? {}
                                : {
                                      onMouseEnter: () => openSubSectionDiv(`ms_${index}`),
                                  })}
                        >
                            {mainSection.url ? (
                                <a
                                    href={`${config.SHIKSHA_STUDYABROAD_HOME}${mainSection?.url}`}
                                    className="level1CustomLink"
                                >
                                    <DrpDownLabel labelActive={labelActive}>
                                        {mainSection.title}
                                    </DrpDownLabel>
                                </a>
                            ) : (
                                <DrpDownLabel labelActive={labelActive}>
                                    {mainSection.title}
                                    <LeftArrowIcon labelActive={labelActive} />
                                </DrpDownLabel>
                            )}
                            <DrpDownRight className="submenu2" labelActive={labelActive}>
                                {rightSubMenuData && (
                                    <RightMenu
                                        rightSubMenuData={rightSubMenuData}
                                        activeLeftTabIndex={labelActive ? `ms_${index}` : ``}
                                        navMenuClick={navMenuClick}
                                    />
                                )}
                            </DrpDownRight>
                        </li>
                    );
                })}
            </ul>
        );
    }, [
        activeLeftTabIndex,
        leftMenuData,
        navMenuClick,
        openSubSectionDiv,
        rightSubMenuData,
        setHamburgerOpenState,
        isMobile,
    ]);
};

export default LeftMenuLi;
